import { ReactNode } from 'react';
import { LiaTimesSolid } from 'react-icons/lia';
import { ToastContainer, toast, Slide, ToastPosition } from 'react-toastify';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { wasErrorToastShown } from '@/utils/functions';

const CloseButton = ({ closeToast }: any) => {
  return (
    <button onClick={closeToast}>
      <LiaTimesSolid className="text-white w-[25px] h-[25px]" />
    </button>
  );
};

const useToast = () => {
  const { isDesktop } = useIsDesktop();

  const scopeToastContainer = (
    <ToastContainer
      enableMultiContainer
      hideProgressBar
      className="absolute"
      containerId="scope"
      position={toast.POSITION.TOP_CENTER}
      transition={Slide}
    />
  );

  const globalToast = (
    message: string | ReactNode,
    position?: ToastPosition
  ) => {
    toast(message, {
      containerId: 'global',
      role: 'alert',
      closeButton: CloseButton,
      position,
      className: 'font-sans font-medium whitespace-pre-line',
    });
  };

  const scopeToast = (
    message: string | ReactNode,
    position?: ToastPosition
  ) => {
    toast(message, {
      containerId: 'scope',
      role: 'alert',
      closeButton: CloseButton,
      position,
      className: 'font-sans font-medium',
    });
  };

  const show = (
    message: string | ReactNode,
    useScoped = false,
    position?: ToastPosition
  ) => {
    if (useScoped) {
      if (isDesktop) {
        scopeToast(message, position && position);
      } else {
        globalToast(message, position && position);
      }
    } else {
      globalToast(message, position && position);
    }
  };

  // Para onError / catch: no repite el toast si axiosErrorHandler ya lo mostró.
  const showError = (error: unknown, fallback?: string, useScoped = false) => {
    if (wasErrorToastShown(error)) return;
    const message = (error as { message?: string } | undefined)?.message;
    show(message || fallback, useScoped);
  };

  return { show, showError, globalToast, scopeToast, scopeToastContainer };
};

export default useToast;
